import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield, X } from 'lucide-react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
    window.dispatchEvent(new Event('cookie-consent-accepted'));
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] px-4 pb-4 animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-3xl mx-auto bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl shadow-black/40 p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-10 h-10 bg-blue-600/20 rounded-xl flex items-center justify-center">
            <Shield className="w-5 h-5 text-blue-400" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-white font-semibold text-base mb-1">We value your privacy</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              We use cookies to analyse site traffic and improve your experience. No tracking runs until you consent.{' '}
              <Link to="/policies/cookies" className="text-blue-400 hover:text-blue-300 underline underline-offset-2">
                Cookie Policy
              </Link>{' '}
              ·{' '}
              <Link to="/policies/privacy" className="text-blue-400 hover:text-blue-300 underline underline-offset-2">
                Privacy Policy
              </Link>
            </p>
            <div className="flex flex-wrap gap-3 mt-4">
              <button
                onClick={accept}
                data-testid="cookie-accept-btn"
                className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg transition-colors"
              >
                Accept All
              </button>
              <button
                onClick={decline}
                data-testid="cookie-decline-btn"
                className="px-5 py-2.5 bg-slate-700 hover:bg-slate-600 text-slate-200 text-sm font-semibold rounded-lg transition-colors"
              >
                Essential Only
              </button>
            </div>
          </div>
          <button
            onClick={decline}
            className="flex-shrink-0 text-slate-500 hover:text-slate-300 transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
